const BuySellHeaderTabs = ({
  active,
  onChange,
  onBack,
  isNewUser,
  totalBalanceUsd,
}) => {
  const isSellDisabled = isNewUser || Number(totalBalanceUsd || 0) <= 0;

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={onBack}
        className="shrink-0 rounded-full p-0 custom-transition hover:bg-option-hover sm:hidden"
        aria-label="Go back"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M15 6L9 12L15 18"
            stroke="#555555"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      <div className="relative flex h-10 w-[192px] shrink-0 items-center justify-between rounded-[28px] border border-[#c4c4c4]/50 bg-background-alt p-1 font-outfit shadow-[inset_0_2px_8px_rgba(0,0,0,0.08)] dark:bg-primary-600 sm:h-12">
        <button
          type="button"
          onClick={() => onChange("Buy")}
          className={`flex items-center justify-center rounded-[24px] px-3 text-sm font-medium leading-[19.5px] custom-transition ${
            active === "Buy"
              ? "h-8 w-[91px] bg-[#333] text-white shadow-[2px_2px_4px_rgba(0,0,0,0.12)] sm:h-10"
              : "h-6 w-[91px] text-text-secondary dark:text-black sm:h-[38px]"
          }`}
        >
          Buy
        </button>

        <button
          type="button"
          disabled={isSellDisabled}
          onClick={() => onChange("Sell")}
          className={`flex items-center justify-center rounded-[24px] px-3 text-sm font-medium leading-[19.5px] custom-transition ${
            active === "Sell" && !isSellDisabled
              ? "h-8 w-[93px] bg-[#333] text-white shadow-[2px_2px_4px_rgba(0,0,0,0.12)] sm:h-10"
              : "h-6 w-[93px] text-text-secondary dark:text-black sm:h-[38px]"
          } disabled:cursor-not-allowed disabled:opacity-40 disabled:pointer-events-none`}
        >
          Sell
        </button>
      </div>
    </div>
  );
};

export default BuySellHeaderTabs;
